import styled from "styled-components";

export const StyledPropertySelectWrapper = styled.div`
  width: ${({ isCollapsed }) => (isCollapsed ? "40px" : "100%")};
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 18px;
  position: relative;
  transition: 0.3s all ease-in-out;
  &.selectProfile {
    max-width: 200px;
  }
  .textFilter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 15px;
    margin-bottom: 8px;
    border-radius: 20px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    background: ${({ $icon }) =>
      $icon ? "${({ theme }) => theme?.light?.primary50};" : "transparent"};
    transition: 0.3s all ease-in-out;
    color: var(--body-text-25);
    span {
      display: flex;
      gap: 10px;
    }
    &:hover {
      background: ${({ theme }) => theme?.light?.primary50};
      color: ${({ theme }) => theme?.light?.primary};
      span {
        img {
          cursor: pointer;
          filter: invert(67%) sepia(69%) saturate(4013%) hue-rotate(344deg)
            brightness(102%) contrast(92%);
        }
      }
    }
    font {
      &:hover {
        background: none !important;
        box-shadow: none !important;
      }
    }
  }
  .active {
    background: ${({ theme }) => theme?.light?.primary50};
    color: ${({ theme }) => theme?.light?.primary};
    span {
      img {
        cursor: pointer;
        filter: invert(67%) sepia(69%) saturate(4013%) hue-rotate(344deg)
          brightness(102%) contrast(92%);
      }
    }
  }
  .iconWrap {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s all ease-in-out;
    transform: ${({ $icon }) => ($icon ? "scale(-1)" : "scale(1)")};
  }
`;
export const ItemWrapper = styled.ul`
  width: 100%;
  z-index: 2;
  width: 100%;
  padding: ${({ $height }) => ($height ? "10px 0" : "0")};
  max-height: ${({ $height }) => ($height ? "200px" : "0")};
  opacity: ${({ $height }) => ($height ? "1" : "0")};
  visibility: ${({ $height }) => ($height ? "visible" : "hidden")};
  overflow: hidden;
  li {
    position: relative;
    background: white !important;
    margin: 0 0 0 35px !important;
    padding: 8px 15px 8px 20px;
    z-index: 2;
    cursor: pointer;
    a {
      color: var(--body-text-25);
      transition: all ease-in-out 0.3s;
    }
    &:before {
      content: "";
      position: absolute;
      width: 10px;
      height: 1px;
      background: var(--body-text-25);
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      transition: all ease-in-out 0.3s;
    }
    &:hover {
      a {
        color: ${({ theme }) => theme?.light?.primary};
      }
      &:before {
        background: ${({ theme }) => theme?.light?.primary};
      }
    }
    .active {
      color: ${({ theme }) => theme?.light?.primary};
      background: transparent;
    }
  }
`;
